import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import styled from "styled-components";

import InputField from "../../ui/form/InputField";
import isValidMass from "../../validators/mass";

const validClass = "mass valid";
const invalidClass = "mass invalid";

const RockMass = styled.span`
    font-weight: bold;
`;

const RockMassField = ({ mass, onChange }) => {

    const [className, setClassName] = useState(validClass);

    const handleChange = (event, onChange) => {
        const massIsValid = isValidMass(event.target.value);

        setClassName(massIsValid ? validClass : invalidClass);

        onChange(event.target.value);
    };
    
    return (
        <RockMass>
            Mass <InputField
                onChange={(event) => handleChange(event, onChange)}
                value={mass}
                className={className}
            />
        </RockMass>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(RockMassField));